var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestExecutionLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Test Execution_Active_16x16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33333 0C0.596953 0 0 0.596953 0 1.33333V14.6666C0 15.403 0.596953 16 1.33333 16H14.6666C15.403 16 16 15.403 16 14.6666V1.33333C16 0.596953 15.403 0 14.6666 0H1.33333ZM3.79508 4.42158C3.79508 3.45186 4.47728 3.05645 5.31873 3.53912L11.5735 7.12616C12.4153 7.60888 12.4153 8.39116 11.5735 8.87399L5.31873 12.4611C4.47728 12.9433 3.79508 12.5484 3.79508 11.5777V4.42158Z",
    fill: "#3B7FF5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6095 0.390518L9.85782 6.14219L11.5736 7.12615C12.4153 7.60888 12.4153 8.39115 11.5736 8.87399L5.31877 12.4611C4.65666 12.8405 4.09315 12.6769 3.88303 12.117L0.390564 15.6095C0.631849 15.8507 0.965182 16 1.33337 16H14.6667C15.4031 16 16 15.403 16 14.6666V1.33333C16 0.965137 15.8508 0.631804 15.6095 0.390518Z",
    fill: "#4D94FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestExecutionLight);
export default __webpack_public_path__ + "static/media/test-execution-light.20d60b8b7ecbb0b5fe13ed25e6c80194.svg";
export { ForwardRef as ReactComponent };